/**
 * Business Registration and Type Constants
 * These values map to Twilio's API requirements
 * See: https://help.twilio.com/articles/38266268244507
 */

// Business Registration Authority options
// Supporting: US, Canada, Australia, New Zealand
export const BUSINESS_REGISTRATION_AUTHORITIES = [
  { value: 'EIN', label: 'EIN (US Employer Identification Number)', country: 'US' },
  { value: 'CBN', label: 'CBN (Canadian Business Number)', country: 'CA' },
  { value: 'PROVINCIAL_NUMBER', label: 'Provincial Number (Canadian Provincial)', country: 'CA' },
  { value: 'ACN', label: 'ACN (Australian Company Number)', country: 'AU' },
  { value: 'ABN', label: 'ABN (Australian Business Number)', country: 'AU' },
  { value: 'NZBN', label: 'NZBN (New Zealand Business Number)', country: 'NZ' },
  { value: 'Other', label: 'Other', country: null }
];

// Business Type options with customer-friendly labels
// The 'value' is what gets sent to Twilio API
// The 'label' is what customers see in the dropdown
export const BUSINESS_TYPES = [
  { value: 'NON_PROFIT', label: 'Non-Profit Organization' },
  { value: 'SOLE_PROPRIETOR', label: 'Sole Proprietorship' },
  { value: 'PRIVATE_PROFIT', label: 'Private For-Profit Company' },
  { value: 'PUBLIC_PROFIT', label: 'Public For-Profit Company' },
  { value: 'GOVERNMENT', label: 'Government Entity' }
];

// Helper to get label from value
export const getBusinessTypeLabel = (value) => {
  const type = BUSINESS_TYPES.find(t => t.value === value);
  return type ? type.label : value;
};

export const getBusinessRegistrationAuthorityLabel = (value) => {
  const authority = BUSINESS_REGISTRATION_AUTHORITIES.find(a => a.value === value);
  return authority ? authority.label : value;
};

// Countries we support (derived from authority options)
export const SUPPORTED_COUNTRIES = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
  { value: 'AU', label: 'Australia' },
  { value: 'NZ', label: 'New Zealand' }
];

// Default business type for Tithely customers (churches/non-profits)
export const DEFAULT_BUSINESS_TYPE = 'NON_PROFIT';
